<section class="overview-header__title">
  <ng-content select="app-overview-header-title" />
</section>
<section class="overview-header__toast">
  @if(overviewHeaderService.toast(); as toast){
  <app-shared-notify-chip [status]="toast.status">
    <app-shared-notify-chip-value>
      {{ toast.localizedText.defaultText | translate : toast.localizedText.token : toast.localizedText.scope }}
    </app-shared-notify-chip-value>
  </app-shared-notify-chip>
  }
</section>
@if(searchComponent()){
<section class="overview-header__filter">
  <mat-form-field>
    <input
      class="overview-header__filter-input"
      [placeholder]="'Suchen' | translate : 'label-search' : 'shared/overview-header'"
      matInput
      [formControl]="tableSearch"
    />
    <div matPrefix>
      <ogs-m3-icon prefix="fal" icon="search" />
    </div>
  </mat-form-field>
</section>
}

<section class="overview-header__chips">
  <section class="filter-chips">
    <ng-content select="app-overview-header-filter-chips" />
  </section>
  <ng-content select="app-overview-header-column-chips" />
</section>

<section class="overview-header__options">
  <ng-content select="app-overview-header-additional-options" />
  <ng-content select="app-table-config-select" />
  <ng-content select="app-overview-header-add" />
  <ng-content select="app-overview-header-operators" />
</section>

@if(filterChipsComponent() || settingsComponent()){
<app-overview-settings-menu />
}
